unit ImportMappings;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  DB,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Grids,
  WEBLib.ExtCtrls,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Data.DB;

type
  TMappingsForm = class(TCoreWebForm)
    ImportMapping: TXDataWebDataSet;
    ImportMappingId: TIntegerField;
    ImportMappingDateAdded: TDateTimeField;
    ImportMappingAddedBy: TIntegerField;
    ImportMappingLastUpdatedBy: TIntegerField;
    ImportMappingLastUpdated: TDateTimeField;
    ImportMappingName: TStringField;
    ImportMappingMapping: TStringField;
    ImportMappingHasTitles: TBooleanField;
    EditTimer: TTimer;
    WebPanel1: TPanel;
    ImportDataTable: TTableControl;
    FormCaption: TLabel;
    MappingNameEdit: TDBEdit;
    DataSource: TDataSource;
    SaveButton: TButton;
    CloseButton: TButton;
    CloseTimer: TTimer;
    FieldItemCheckDlg: TMessageDlg;
    DateDelimiterEdit: TEdit;
    DateFormatEdit: TEdit;
    procedure CloseButtonClick(Sender: TObject);
    procedure CloseTimerTimer(Sender: TObject);
    procedure EditTimerTimer(Sender: TObject);
    procedure ImportMappingAfterPost(Dataset: TDataSet);
    procedure MappingNameEditChange(Sender: TObject);
    procedure SaveButtonClick(Sender: TObject);
    procedure DateDelimiterEditKeyPress(Sender: TObject; var Key: Char);
    procedure DateFormatEditKeyPress(Sender: TObject; var Key: Char);
    procedure DateDelimiterEditExit(Sender: TObject);
    procedure DateFormatEditExit(Sender: TObject);
  private
    { Private declarations }
    fImportMapping: TDataSet;
    FImportRowData: TStringList;
    FJSONImportData: string;
    FDelimiter: char;
    FHasHeadings: boolean;
    fMappingName: string;
    [async]
    FJSONFileData: string;
    FTempFileName: string;
    FIsXLSFile: boolean;

    FDateFormat: string;
    FDateDelimiter: string;

    procedure SetJSONFileData(JSONFileData: string);
    procedure ParseJSONImportData;
    procedure AddDataToGrid(AColumnCount: integer; ARowCount: integer; ADataRow: TArray<string>);
    function TestFieldForHeader:boolean;
    procedure ConfigureGrid(HeaderData: TArray<string>; AColumnCount: integer);
    procedure CreateComboBoxes(AColumnCount: integer);
    procedure UpdateComboBoxs;
    procedure SaveMapping;
    function GetJSONMappingData: string;
    procedure SetDataset(Value: TDataSet);
    [async]
    procedure CloseMappingForm; async;
    [async]
    procedure ComboBoxChange(Sender: TObject); async;
    //function IsXLSNumericDate(ADate: string):boolean;
    function IsXLSNumericDate(AData: string; var ADateStr: string):boolean;
    function XLSFormatDate(lDataValue: string): string;

  public
    { Public declarations }
    property JSONFileData: string read FJSONFileData write SetJSONFileData;
    property Delimiter: char read FDelimiter write FDelimiter;
    property MappingName: string read fMappingName write fMappingName;
    property TempFileName: string  read FTempFileName;
  protected procedure LoadDFMValues; override; end;

var
  MappingsForm: TMappingsForm;

implementation

{$R *.dfm}

uses
  XData.Web.Client,
  SMX.Web.Layout.Utils,
  MainDataModule, SMX.Jobs.Shared;

const
  ComboFieldItems = ',Title,Firstname,Lastname,FullName,Add1,Add2,Add3,City,County,' +
    'PostCode,FullAddress,Country,Date,Amount,ExternalId,External_DonationId,Sponsored';

  Date20200101 = 43831;  //Check its a date and above 01/01/2020

procedure TMappingsForm.ConfigureGrid(HeaderData: TArray<string>; AColumnCount: integer);
var
  ColIdx, RowIdx: integer;
  lHeaderName: string;
begin
  FImportRowData := TStringList.Create;
  FImportRowData.Delimiter := ',';

  for lHeaderName in HeaderData do
    FImportRowData.Add(lHeaderName);

  ImportDataTable.ColCount := AColumnCount;
  ImportDataTable.RowCount := 7;
end;

procedure TMappingsForm.CreateComboBoxes(AColumnCount: integer);
var
  DataComboBox: TComboBox;
  Idx: integer;
  ComboNameId: string;
begin
  for Idx := 0 to AColumnCount - 1 do
  begin
    DataComboBox := TComboBox.Create(Self);
    ComboNameId := Format('WebCombo%0.2d', [Idx]);
    DataComboBox.Parent := WebPanel1;
    DataComboBox.ElementID := ComboNameId;
    DataComboBox.Name := ComboNameId;
    DataComboBox.ElementClassName := 'form-select';
    DataComboBox.ElementPosition := epIgnore;
    DataComboBox.HeightStyle := ssAuto;
    DataComboBox.WidthStyle := ssAuto;
    FImportRowData.Objects[Idx] := DataComboBox;
    DataComboBox.Items.DelimitedText := ComboFieldItems;
    DataComboBox.OnChange := ComboBoxChange;
    ImportDataTable.Cells[Idx, 1] := '';
    ImportDataTable.CellElements[Idx, 1].appendChild(DataComboBox.ElementHandle);
  end;
end;

procedure TMappingsForm.DateDelimiterEditExit(Sender: TObject);
begin
  inherited;
  FDateDelimiter := DateDelimiterEdit.Text;
end;

procedure TMappingsForm.DateDelimiterEditKeyPress(Sender: TObject;
  var Key: Char);
begin
  DateDelimiterEdit.Text := '';
  if Key in ['0'..'9', 'a'..'z', 'A'..'Z'] then
    Key := #0;
end;

procedure TMappingsForm.DateFormatEditExit(Sender: TObject);
begin
  inherited;
  FDateFormat := DateFormatEdit.Text;
end;

procedure TMappingsForm.DateFormatEditKeyPress(Sender: TObject; var Key: Char);
begin
  if (not (Key in ['d', 'D','m', 'M', 'y', 'Y']))  then
    Key := #0
  else if ((Pos(Key, DateFormatEdit.Text) <> 0) or (Pos(Key, Lowercase(DateFormatEdit.Text)) <> 0)) then
    Key := #0;
end;

procedure TMappingsForm.ParseJSONImportData;
var
  JSImportData: TJSObject;
  lFileName: string;
  lIdx: integer;
  lRowCount: integer;
  lRowIdx: integer;
  lColumnCount: integer;
  lJSONImportData: string;
  lImportData: TImportData;
  lData: TArray<TArray<string>>;
  lRowData: TArray<string>;

begin
  lJSONImportData := FJSONImportData;
  JSImportData := TJSJSON.parseObject(lJSONImportData);
  lImportData := TImportData(JSImportData);

  lFileName := lImportData.OriginalFileName;
  FTempFileName := lImportData.TempFileName;

  if Pos('.xls', lFileName) > 0 then
    FIsXLSFile := true
  else
    FIsXLSFile := false;

  lColumnCount := lImportData.ColCount;
  FHasHeadings := lImportData.HasTitles;
  lData := lImportData.Data;
  lRowCount := Length(lData);

  for lIdx := 0 to Length(lData) - 1 do
  begin
    lRowData := lData[lIdx];

    if lIdx < 1 then
    begin
      ConfigureGrid(lRowData, lColumnCount);
      lRowIdx := 0;
      AddDataToGrid(lColumnCount, 0, lRowData);
      CreateComboBoxes(lColumnCount);
    end
    else
    begin
      lRowIdx := lIdx + 1;
      AddDataToGrid(lColumnCount, lRowIdx, lRowData);
    end;
  end;

  FHasHeadings := TestFieldForHeader;
end;

procedure TMappingsForm.AddDataToGrid(AColumnCount: integer; ARowCount: integer; ADataRow: TArray<string>);
var
  lCol, lRow: integer;
  lDataValue: string;
  lFormattedDate: string;
begin
  lRow := ARowCount;
  try
    try
      for lCol := 0 to Length(ADataRow) - 1 do
      begin
        lDataValue := ADataRow[lCol];

        if FIsXLSFile and IsXLSNumericDate(lDataValue, lFormattedDate) then
          ImportDataTable.Cells[lCol, lRow] := lFormattedDate
        else
          ImportDataTable.Cells[lCol, lRow] := lDataValue;
      end;
    except

    end;
  finally

  end;
end;

procedure TMappingsForm.CloseButtonClick(Sender: TObject);
begin
  inherited;
  CloseMappingForm;
end;

procedure TMappingsForm.CloseMappingForm;
var
  res: TModalResult;
begin
  res := await(TModalResult,
    MessageDlgAsync('Are you sure you want to cancel this mapping? Any changes will not be saved', mtConfirmation, [mbYes, mbNo]));
  if res = mrYes then
     ModalResult := mrClose;
end;

procedure TMappingsForm.CloseTimerTimer(Sender: TObject);
begin
  // inherited;
  CloseTimer.Enabled := False;
  ModalResult := mrOK;
end;

procedure TMappingsForm.EditTimerTimer(Sender: TObject);
begin
  inherited;
  ImportMapping.Insert;
  EditTimer.Enabled := False;
end;

procedure TMappingsForm.SaveButtonClick(Sender: TObject);
begin
  inherited;
  SaveMapping;
  SaveButton.Enabled := False;
  CloseTimer.Enabled := true;
end;

function TMappingsForm.GetJSONMappingData: string;
var
  Idx: integer;
  sFieldName: string;
  WC_Object: TJSObject;
  MyString: string;
  JSONData: string;
  MapData: string;
  FieldCombo: TComboBox;
  FieldTitle: string;
  UserTitle: string;
  lLen: integer;

begin
  JSONData := '{ ';
  for Idx := 0 to FImportRowData.Count - 1 do
  begin
    FieldCombo := TComboBox(FImportRowData.Objects[Idx]);

    if assigned(FieldCombo) then
    begin
      FieldTitle := FieldCombo.Text;
      UserTitle  := ImportDataTable.Cells[Idx, 0];

      if FieldTitle <> '' then
      begin
        MapData := Format('"%s":%d,', [FieldTitle, Idx]);
        JSONData := JSONData + MapData;
        MapData := Format('"user%s":"%s",', [FieldTitle, UserTitle]);
        JSONData := JSONData + MapData;
      end;
    end;
  end;

  if FDateFormat <> '' then
  begin
    MapData := Format('"%s":"%s",', ['DateFormat', FDateFormat]);
    JSONData := JSONData + MapData;
  end;

  if FDateDelimiter <> '' then
  begin
    MapData := Format('"%s":"%s",', ['DateDelimiter', FDateDelimiter]);
    JSONData := JSONData + MapData;
  end;

  lLen := Length(JSONData);
  JSONData[lLen] := ' ';
  JSONData := JSONData + '}';
  result := JSONData;
end;

procedure TMappingsForm.ImportMappingAfterPost(Dataset: TDataSet);
begin
  inherited;
  ImportMapping.ApplyUpdates;
end;

procedure TMappingsForm.MappingNameEditChange(Sender: TObject);
begin
  inherited;
  fMappingName := MappingNameEdit.Text;

  // if FMappingName <> '' then
  SaveButton.Enabled := fMappingName <> '';
end;

procedure TMappingsForm.SetDataset(Value: TDataSet);
begin
  DataSource.Dataset := Value;
end;

procedure TMappingsForm.SetJSONFileData(JSONFileData: string);
begin
  FJSONImportData := JSONFileData;
  ParseJSONImportData;
  ImportMapping.Load;
  EditTimer.Enabled := true;
end;

procedure TMappingsForm.UpdateComboBoxs;
begin

end;

procedure TMappingsForm.SaveMapping;
var
  MappingData: string;
begin
  MappingData := GetJSONMappingData;

  if MappingData <> '' then
  begin
    ImportMapping.FieldByName('Mapping').AsString := MappingData;
    ImportMapping.FieldByName('HasTitles').AsBoolean := FHasHeadings;
    ImportMapping.Post;
  end;
end;


function TMappingsForm.TestFieldForHeader: boolean;
var
  Idx: integer;
  DataComboBox: TComboBox;
  lHeaderIdx: integer;
  lResult: string;
  lValue: string;
  lHasHeadings: boolean;

  function TestHead(ATest, AHeader: string):boolean;
  begin
    result := Pos(Uppercase(ATest), Uppercase(AHeader)) > 0;
  end;

begin
  lHasHeadings := false;

  for Idx := 0 to FImportRowData.Count-1  do
  begin
    DataComboBox := TComboBox(FImportRowData.Objects[Idx]);

    if assigned(DataComboBox) then
    begin
      lValue := ImportDataTable.Cells[Idx, 0];

      lResult := '';
      if TestHead('FullName', lValue) then
        lResult := 'FullName'
      else if TestHead('FullAddress', lValue) then
        lResult := 'FullAddress'
      else if TestHead('Title', lValue) then
        lResult := 'Title'
      else if TestHead('First', lValue) or TestHead('GivenName', lValue) or  TestHead('Christian', lValue) then
        lResult := 'Firstname'
      else if TestHead('Last', lValue) or TestHead('Surname', lValue) then
        lResult := 'Lastname'
      else if TestHead('Add1', lValue) or TestHead('Address1', lValue) then
        lResult := 'Add1'
      else if TestHead('Add2', lValue) or TestHead('Address2', lValue) then
        lResult := 'Add2'
      else if TestHead('Add3', lValue) or TestHead('Address3', lValue) then
        lResult := 'Add3'
      else if TestHead('City', lValue) then
        lResult := 'City'
      else if TestHead('County', lValue) then
        lResult := 'County'
      else if TestHead('Post', lValue) then
        lResult := 'PostCode'
      else if TestHead('Country', lValue) then
        lResult := 'Country'
      else if TestHead('Date', lValue) then
        lResult := 'Date'
      else if TestHead('Amount', lValue) or (TestHead('Donation', lValue) and
              (not TestHead('Date', lValue)) and (not TestHead('ID', lValue))) then
        lResult := 'Amount'
      else if (TestHead('Ext', lValue) and TestHead('Donor', lValue)) or
              (TestHead('Donor', lValue) and TestHead('Id', lValue))  then
        lResult := 'ExternalId'
      else if ((TestHead('Ext', lValue) and TestHead('Donat', lValue))) or
              (TestHead('Donat', lValue) and TestHead('Id', lValue))  then
        lResult := 'External_DonationId'
      else if TestHead('Spons', lValue) then
        lResult := 'Sponsored';

      if lResult <> '' then
      begin
        lHeaderIdx := DataComboBox.Items.IndexOf(lResult);
        DataComboBox.ItemIndex := lHeaderIdx;
        lHasHeadings := true;
      end
      else
      begin
        // First Item in the combo box is a blank space
        DataComboBox.ItemIndex := 0;
      end;
    end;
  end;

  result := lHasHeadings;
end;

procedure TMappingsForm.ComboBoxChange(Sender: TObject);
var
  lIdx: integer;
  DataComboBox: TComboBox;
  lSelectedFieldItem: string;
  lCount: integer;
  lRes: TModalResult;

begin
  lCount := 0;
  lSelectedFieldItem := TComboBox(Sender).Text;

  for lIdx := 0 to FImportRowData.Count-1 do
  begin
    DataComboBox := TComboBox(FImportRowData.Objects[lIdx]);

    if assigned(DataComboBox) then
    begin
      if DataComboBox.Text = lSelectedFieldItem then
      begin
        inc(lCount);
      end;
    end;
  end;

  if lCount = 2 then
  begin
    lRes := await(TModalResult, FieldItemCheckDlg.ShowDialog('This field has already been selected', WEBLib.Dialogs.mtWarning, [mbOk]));
    TComboBox(Sender).ItemIndex := 0;
  end;
end;

function TMappingsForm.IsXLSNumericDate(AData: string; var ADateStr: string):boolean;
var
  lIsXLS: boolean;
  lPos: integer;
  lDate: TDateTime;
begin
  lPos := Pos('.', AData);
  //Reduce checking
  if lPos > 0 then
  begin
    try
      lDate := strtofloat(AData);
      lIsXLS := true;
    except
      lIsXLS := False;
    end;

    if lIsXLS then
    begin
      if lDate > Date20200101 then
      begin
        ADateStr := FormatDateTime('dd/mm/yyyy', lDate);
        lIsXLS := True
      end
      else
        lIsXLS := False;
    end;
  end
  else
    lIsXLS := False;

  result := lIsXLS;
end;

function TMappingsForm.XLSFormatDate(lDataValue: string): string;
var
  lDataVal: double;
  lDateStr: string;
begin
  lDataVal := lDataValue.ToDouble;

  lDateStr := FormatDateTime('dd/mm/yyyy', lDataVal);

  result := lDateStr;
end;


procedure TMappingsForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  FormCaption := TLabel.Create('FormCaption');
  WebPanel1 := TPanel.Create(Self);
  ImportDataTable := TTableControl.Create('MappingTable');
  MappingNameEdit := TDBEdit.Create('MappingNameEdit');
  SaveButton := TButton.Create('SaveButton');
  CloseButton := TButton.Create('CloseButton');
  FieldItemCheckDlg := TMessageDlg.Create(Self);
  DateDelimiterEdit := TEdit.Create('DateDelimiter');
  DateFormatEdit := TEdit.Create('DateFormat');
  ImportMapping := TXDataWebDataSet.Create(Self);
  ImportMappingId := TIntegerField.Create(Self);
  ImportMappingDateAdded := TDateTimeField.Create(Self);
  ImportMappingAddedBy := TIntegerField.Create(Self);
  ImportMappingLastUpdatedBy := TIntegerField.Create(Self);
  ImportMappingLastUpdated := TDateTimeField.Create(Self);
  ImportMappingName := TStringField.Create(Self);
  ImportMappingMapping := TStringField.Create(Self);
  ImportMappingHasTitles := TBooleanField.Create(Self);
  EditTimer := TTimer.Create(Self);
  DataSource := TDataSource.Create(Self);
  CloseTimer := TTimer.Create(Self);

  FormCaption.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  ImportDataTable.BeforeLoadDFMValues;
  MappingNameEdit.BeforeLoadDFMValues;
  SaveButton.BeforeLoadDFMValues;
  CloseButton.BeforeLoadDFMValues;
  FieldItemCheckDlg.BeforeLoadDFMValues;
  DateDelimiterEdit.BeforeLoadDFMValues;
  DateFormatEdit.BeforeLoadDFMValues;
  ImportMapping.BeforeLoadDFMValues;
  ImportMappingId.BeforeLoadDFMValues;
  ImportMappingDateAdded.BeforeLoadDFMValues;
  ImportMappingAddedBy.BeforeLoadDFMValues;
  ImportMappingLastUpdatedBy.BeforeLoadDFMValues;
  ImportMappingLastUpdated.BeforeLoadDFMValues;
  ImportMappingName.BeforeLoadDFMValues;
  ImportMappingMapping.BeforeLoadDFMValues;
  ImportMappingHasTitles.BeforeLoadDFMValues;
  EditTimer.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  CloseTimer.BeforeLoadDFMValues;
  try
    Width := 939;
    Height := 611;
    FormCaption.SetParentComponent(Self);
    FormCaption.Name := 'FormCaption';
    FormCaption.Left := 72;
    FormCaption.Top := 10;
    FormCaption.Width := 140;
    FormCaption.Height := 25;
    FormCaption.Margins.Left := 5;
    FormCaption.Margins.Top := 5;
    FormCaption.Margins.Right := 5;
    FormCaption.Margins.Bottom := 5;
    FormCaption.Caption := 'Import Mappings';
    FormCaption.ElementClassName := 'HeadlineClass';
    FormCaption.ElementFont := efCSS;
    FormCaption.ElementPosition := epIgnore;
    FormCaption.HeightStyle := ssAuto;
    FormCaption.HeightPercent := 100.000000000000000000;
    FormCaption.HTMLType := tDIV;
    FormCaption.WidthStyle := ssAuto;
    FormCaption.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 54;
    WebPanel1.Top := 334;
    WebPanel1.Width := 561;
    WebPanel1.Height := 38;
    WebPanel1.HeightStyle := ssAuto;
    WebPanel1.WidthStyle := ssAuto;
    WebPanel1.Caption := 'WebPanel1';
    WebPanel1.ChildOrder := 20;
    WebPanel1.ElementFont := efCSS;
    WebPanel1.ElementPosition := epIgnore;
    WebPanel1.TabOrder := 0;
    WebPanel1.Visible := False;
    ImportDataTable.SetParentComponent(Self);
    ImportDataTable.Name := 'ImportDataTable';
    ImportDataTable.Left := 54;
    ImportDataTable.Top := 115;
    ImportDataTable.Width := 561;
    ImportDataTable.Height := 200;
    ImportDataTable.HeightStyle := ssAuto;
    ImportDataTable.WidthStyle := ssAuto;
    ImportDataTable.BorderColor := clSilver;
    ImportDataTable.ChildOrder := 13;
    ImportDataTable.ElementFont := efCSS;
    ImportDataTable.ElementPosition := epIgnore;
    ImportDataTable.RowCount := 5;
    MappingNameEdit.SetParentComponent(Self);
    MappingNameEdit.Name := 'MappingNameEdit';
    MappingNameEdit.Left := 400;
    MappingNameEdit.Top := 71;
    MappingNameEdit.Width := 215;
    MappingNameEdit.Height := 22;
    MappingNameEdit.AutoCompletion := acNone;
    MappingNameEdit.ChildOrder := 11;
    MappingNameEdit.ElementClassName := 'form-control';
    MappingNameEdit.ElementFont := efCSS;
    MappingNameEdit.ElementPosition := epIgnore;
    MappingNameEdit.HeightStyle := ssAuto;
    MappingNameEdit.HeightPercent := 100.000000000000000000;
    MappingNameEdit.Text := 'MappingNameEdit';
    MappingNameEdit.WidthStyle := ssAuto;
    MappingNameEdit.WidthPercent := 100.000000000000000000;
    SetEvent(MappingNameEdit, Self, 'OnChange', 'MappingNameEditChange');
    MappingNameEdit.DataField := 'Name';
    MappingNameEdit.DataSource := DataSource;
    SaveButton.SetParentComponent(Self);
    SaveButton.Name := 'SaveButton';
    SaveButton.Left := 416;
    SaveButton.Top := 448;
    SaveButton.Width := 96;
    SaveButton.Height := 25;
    SaveButton.Caption := 'Save';
    SaveButton.ChildOrder := 5;
    SaveButton.ElementClassName := 'btn btn-secondary';
    SaveButton.ElementPosition := epIgnore;
    SaveButton.Enabled := False;
    SaveButton.HeightStyle := ssAuto;
    SaveButton.HeightPercent := 100.000000000000000000;
    SaveButton.WidthStyle := ssAuto;
    SaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveButton, Self, 'OnClick', 'SaveButtonClick');
    CloseButton.SetParentComponent(Self);
    CloseButton.Name := 'CloseButton';
    CloseButton.Left := 519;
    CloseButton.Top := 448;
    CloseButton.Width := 96;
    CloseButton.Height := 25;
    CloseButton.Caption := 'Close';
    CloseButton.ChildOrder := 6;
    CloseButton.ElementClassName := 'btn btn-secondary';
    CloseButton.ElementPosition := epIgnore;
    CloseButton.HeightStyle := ssAuto;
    CloseButton.HeightPercent := 100.000000000000000000;
    CloseButton.WidthStyle := ssAuto;
    CloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseButton, Self, 'OnClick', 'CloseButtonClick');
    FieldItemCheckDlg.SetParentComponent(Self);
    FieldItemCheckDlg.Name := 'FieldItemCheckDlg';
    FieldItemCheckDlg.Left := 664;
    FieldItemCheckDlg.Top := 368;
    FieldItemCheckDlg.Width := 24;
    FieldItemCheckDlg.Height := 24;
    FieldItemCheckDlg.Buttons := [];
    FieldItemCheckDlg.Opacity := 0.200000000000000000;
    DateDelimiterEdit.SetParentComponent(Self);
    DateDelimiterEdit.Name := 'DateDelimiterEdit';
    DateDelimiterEdit.Left := 40;
    DateDelimiterEdit.Top := 536;
    DateDelimiterEdit.Width := 41;
    DateDelimiterEdit.Height := 22;
    DateDelimiterEdit.AutoCompletion := acNone;
    DateDelimiterEdit.ChildOrder := 7;
    DateDelimiterEdit.ElementClassName := 'form-control';
    DateDelimiterEdit.ElementPosition := epIgnore;
    DateDelimiterEdit.HeightStyle := ssAuto;
    DateDelimiterEdit.HeightPercent := 100.000000000000000000;
    DateDelimiterEdit.MaxLength := 1;
    DateDelimiterEdit.WidthStyle := ssAuto;
    DateDelimiterEdit.WidthPercent := 100.000000000000000000;
    SetEvent(DateDelimiterEdit, Self, 'OnExit', 'DateDelimiterEditExit');
    SetEvent(DateDelimiterEdit, Self, 'OnKeyPress', 'DateDelimiterEditKeyPress');
    DateFormatEdit.SetParentComponent(Self);
    DateFormatEdit.Name := 'DateFormatEdit';
    DateFormatEdit.Left := 112;
    DateFormatEdit.Top := 536;
    DateFormatEdit.Width := 121;
    DateFormatEdit.Height := 22;
    DateFormatEdit.AutoCompletion := acNone;
    DateFormatEdit.CharCase := wecUpperCase;
    DateFormatEdit.ChildOrder := 8;
    DateFormatEdit.ElementClassName := 'form-control';
    DateFormatEdit.ElementPosition := epIgnore;
    DateFormatEdit.HeightStyle := ssAuto;
    DateFormatEdit.HeightPercent := 100.000000000000000000;
    DateFormatEdit.MaxLength := 3;
    DateFormatEdit.WidthStyle := ssAuto;
    DateFormatEdit.WidthPercent := 100.000000000000000000;
    SetEvent(DateFormatEdit, Self, 'OnExit', 'DateFormatEditExit');
    SetEvent(DateFormatEdit, Self, 'OnKeyPress', 'DateFormatEditKeyPress');
    ImportMapping.SetParentComponent(Self);
    ImportMapping.Name := 'ImportMapping';
    ImportMapping.AfterPost := ImportMappingAfterPost;
    ImportMapping.EntitySetName := 'ImportMappings';
    ImportMapping.Connection := MainData.DataConnection;
    ImportMapping.Left := 48;
    ImportMapping.Top := 452;
    ImportMappingId.SetParentComponent(ImportMapping);
    ImportMappingId.Name := 'ImportMappingId';
    ImportMappingId.FieldName := 'Id';
    ImportMappingDateAdded.SetParentComponent(ImportMapping);
    ImportMappingDateAdded.Name := 'ImportMappingDateAdded';
    ImportMappingDateAdded.FieldName := 'DateAdded';
    ImportMappingAddedBy.SetParentComponent(ImportMapping);
    ImportMappingAddedBy.Name := 'ImportMappingAddedBy';
    ImportMappingAddedBy.FieldName := 'AddedBy';
    ImportMappingLastUpdatedBy.SetParentComponent(ImportMapping);
    ImportMappingLastUpdatedBy.Name := 'ImportMappingLastUpdatedBy';
    ImportMappingLastUpdatedBy.FieldName := 'LastUpdatedBy';
    ImportMappingLastUpdated.SetParentComponent(ImportMapping);
    ImportMappingLastUpdated.Name := 'ImportMappingLastUpdated';
    ImportMappingLastUpdated.FieldName := 'LastUpdated';
    ImportMappingName.SetParentComponent(ImportMapping);
    ImportMappingName.Name := 'ImportMappingName';
    ImportMappingName.FieldName := 'Name';
    ImportMappingName.Size := 255;
    ImportMappingMapping.SetParentComponent(ImportMapping);
    ImportMappingMapping.Name := 'ImportMappingMapping';
    ImportMappingMapping.FieldName := 'Mapping';
    ImportMappingMapping.Size := 4096;
    ImportMappingHasTitles.SetParentComponent(ImportMapping);
    ImportMappingHasTitles.Name := 'ImportMappingHasTitles';
    ImportMappingHasTitles.FieldName := 'HasTitles';
    EditTimer.SetParentComponent(Self);
    EditTimer.Name := 'EditTimer';
    EditTimer.Enabled := False;
    SetEvent(EditTimer, Self, 'OnTimer', 'EditTimerTimer');
    EditTimer.Left := 456;
    EditTimer.Top := 384;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ImportMapping;
    DataSource.Left := 280;
    DataSource.Top := 40;
    CloseTimer.SetParentComponent(Self);
    CloseTimer.Name := 'CloseTimer';
    CloseTimer.Enabled := False;
    CloseTimer.Interval := 1500;
    SetEvent(CloseTimer, Self, 'OnTimer', 'CloseTimerTimer');
    CloseTimer.Left := 72;
    CloseTimer.Top := 376;
  finally
    FormCaption.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    ImportDataTable.AfterLoadDFMValues;
    MappingNameEdit.AfterLoadDFMValues;
    SaveButton.AfterLoadDFMValues;
    CloseButton.AfterLoadDFMValues;
    FieldItemCheckDlg.AfterLoadDFMValues;
    DateDelimiterEdit.AfterLoadDFMValues;
    DateFormatEdit.AfterLoadDFMValues;
    ImportMapping.AfterLoadDFMValues;
    ImportMappingId.AfterLoadDFMValues;
    ImportMappingDateAdded.AfterLoadDFMValues;
    ImportMappingAddedBy.AfterLoadDFMValues;
    ImportMappingLastUpdatedBy.AfterLoadDFMValues;
    ImportMappingLastUpdated.AfterLoadDFMValues;
    ImportMappingName.AfterLoadDFMValues;
    ImportMappingMapping.AfterLoadDFMValues;
    ImportMappingHasTitles.AfterLoadDFMValues;
    EditTimer.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    CloseTimer.AfterLoadDFMValues;
  end;
end;

end.
